import { render, staticRenderFns } from "./DonationContractTemplatesView.vue?vue&type=template&id=07377d70&scoped=true&"
import script from "./DonationContractTemplatesView.vue?vue&type=script&lang=js&"
export * from "./DonationContractTemplatesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07377d70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle})
